import React, { useState } from 'react';
import { Popover } from 'antd';
import { Colors } from '../../../../../../../constants/colors.constants.js';
import { TrashAllIcon } from '../../../../../../../icons';

export const DependenciesRemoveAllPopover = ({ onClickButtonDelete, t }) => {
  const [visible, setVisible] = useState(false);

  const handleVisibleChange = (newVisible) => setVisible(newVisible);

  const deletePopover = () => {
    handleVisibleChange(false);
    onClickButtonDelete();
  };

  const content = (
    <div className="remove-all-alert-popover">
      <h6>{t('activity_card.title_popover_all_remove_task')}</h6>
      <div className="alert-popover__buttons">
        <button
          className="buttons__cancel"
          onClick={() => handleVisibleChange(false)}>
          {t('activity_card.text_button_cancel_all_remove_task')}
        </button>
        <button className="buttons__delete" onClick={() => deletePopover()}>
          {t('activity_card.text_button_ok_all_remove_task')}
        </button>
      </div>
    </div>
  );

  return (
    <Popover
      visible={visible}
      onVisibleChange={handleVisibleChange}
      content={content}
      trigger="click"
      overlayClassName="overlay-remove-all-alert-popover">
      <div style={{ cursor: 'pointer' }}>
        <TrashAllIcon color={Colors.BLACK} />
      </div>
    </Popover>
  );
};

export default DependenciesRemoveAllPopover;
